export class ValidationRegistry {
    constructor() {
        this.validators = new Map();
        this.initialized = false;
    }
    register(name, validator) {
        this.validators.set(name, validator);
    }
    getValidator(name) {
        return this.validators.get(name);
    }
    markInitialized() {
        this.initialized = true;
        return this;
    }
    isInitialized() {
        return this.initialized;
    }
    validate(data) {
        const result = [];
        this.validators.forEach((validator) => {
            const validationErrors = validator(data);
            if (validationErrors.length) {
                result.push(...validationErrors);
            }
        });
        return result;
    }
}
//# sourceMappingURL=validationRegistry.js.map